import { makeStyles } from 'tss-react/mui';

export const RACHEL_ANSWER_ACTIONS_SPACING_TOP = 1;

export const RACHEL_PROMPT_ACTIONS_SPACING_TOP = 0.5;

const ACTION_BUTTON_SIZE = 22;

interface RachelMessageActionsStylesParams {
  shouldRevealOnHover: boolean;
  spacingTop: number;
  hasActions?: boolean;
}

export const useRachelMessageActionsStyles = makeStyles<
  RachelMessageActionsStylesParams,
  'actions'
>()((theme, { shouldRevealOnHover, spacingTop, hasActions = true }, classes) => ({
  root: {
    paddingBottom: hasActions ? 0 : `calc(${theme.spacing(spacingTop)} + ${ACTION_BUTTON_SIZE}px)`,
    [`&:hover .${classes.actions}, &:focus-within .${classes.actions}`]: {
      opacity: 1,
    },
  },
  actions: {
    display: 'flex',
    gap: theme.spacing(0.5),
    paddingTop: theme.spacing(spacingTop),
    opacity: shouldRevealOnHover ? 0 : 1,
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shorter,
    }),
    '@media (hover: none)': {
      opacity: 1,
    },
  },
}));

export const useRachelMessageActionButtonStyles = makeStyles()((theme) => ({
  actionButton: {
    '&.MuiIconButton-root': {
      color: theme.palette.text.secondary,
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
      },
    },
  },
  actionButtonActive: {
    '&.MuiIconButton-root': {
      color: theme.palette.accent.dark,
    },
  },
}));
